import { ApexOptions } from 'apexcharts';
import React, { useMemo, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import CoreTooltip from 'shared/CoreTooltip';
import useCommonStore from 'store/useCommonStore';
import styled, { useTheme } from 'styled-components';
import { roundFloat } from 'utils/round';

const TableGraphCellInner = ({ growth_list }: { growth_list?: number[] }) => {
	const theme = useTheme();

	const { is_scroll } = useCommonStore();

	const [tooltip_content, setTooltipContent] = useState('');
	const [is_in_graph, setIsInGraph] = useState(false);

	const result_list = useMemo(() => {
		if (growth_list === undefined) return new Array(6).fill(null);

		const null_mapped_growth_list: (number | null)[] = growth_list;

		for (let i = 0; i < null_mapped_growth_list.length - 1; i++) {
			if (null_mapped_growth_list[i] === 0) null_mapped_growth_list[i] = null;
			else if (null_mapped_growth_list[i] !== 0) break;
		}

		return null_mapped_growth_list;
	}, [growth_list]);

	const [is_axis_x, setIsAxisX] = useState(false);

	const chart: ApexOptions = useMemo((): ApexOptions => {
		return {
			chart: {
				id: 'basic-line',
				type: 'bar',
				width: 200,
				height: '80%',
				toolbar: {
					show: false,
				},
				zoom: { enabled: false },
				// events: {
				// 	mouseMove: function (event, chartContext, config) {
				// 		const tooltip = chartContext.el.querySelector('.chart-tooltip-wrapper');
				// 		// const pointsArray = config.globals.pointsArray;
				// 		const pointsArray = config.globals.seriesXvalues[1];
				// 		const seriesIndex = config.seriesIndex;
				// 		const dataPointIndex = config.dataPointIndex === -1 ? 0 : config.dataPointIndex;

				// 		console.log(chartContext.el);
				// 		console.log(config);

				// 		if (seriesIndex !== -1 && dataPointIndex !== -1) {
				// 			const position = pointsArray[dataPointIndex];

				// 			console.log(tooltip.style.top, tooltip.style.left);
				// 			console.log(position);

				// 			// tooltip.style.top = position[1] + 'px';
				// 			tooltip.style.top = '0px';

				// 			tooltip.style.left = position + 'px';
				// 			setX(position);
				// 		}
				// 	},
				// },
				events: {
					mouseMove(event, chartContext, config) {
						const pointsArray = config.globals.seriesXvalues[1];
						const seriesIndex = config.seriesIndex;
						const dataPointIndex = config.dataPointIndex;

						if (is_in_graph === false && dataPointIndex > -1) setIsInGraph(true);
						if (is_in_graph === true && dataPointIndex === -1) setIsInGraph(false);

						console.log(tooltip_content === '');
					},
					mouseLeave() {
						setIsInGraph(false);
					},
					mounted(chart) {
						if (chart && chart.bar.baseLineY[0] < 0) setIsAxisX(true);
					},
				},
			},
			colors: [theme.colors.system.red, theme.colors.system.red_lighten],
			stroke: {
				width: [2, 0],
				lineCap: 'round',
			},
			states: {
				hover: {
					filter: {
						type: 'none',
					},
				},
				active: {
					filter: {
						type: 'none',
					},
				},
			},
			plotOptions: {
				bar: {
					columnWidth: '70%',
					colors: {
						ranges: [{ from: -Infinity, to: 0, color: theme.colors.system.red_lighten }],
					},
				},
			},
			grid: {
				borderColor: 'transparent',
			},
			annotations: {
				yaxis: [
					{
						y: 0,
						strokeDashArray: 0,
						borderColor: theme.colors.gray.gray15,
						fillColor: theme.colors.gray.gray15,
						borderWidth: 1,
						offsetX: -16,
						offsetY: 0,
						width: is_axis_x ? '0' : '128px',
					},
				],
			},
			xaxis: {
				labels: { show: false },
				axisBorder: {
					show: is_axis_x,
					color: theme.colors.gray.gray15,
				},
				categories: ['6달 전', '5달 전', '4달 전', '3달 전', '2달 전', '지난 달'],
				tooltip: { enabled: false },
			},
			yaxis: { labels: { show: false } },
			dataLabels: {
				enabled: false,
			},
			tooltip: {
				// enabled: false,
				cssClass: 'chart-tooltip-wrapper',
				// fixed: { enabled: true, offsetX: offset.x, offsetY: offset.y },
				fixed: { enabled: true, offsetX: -5000, offsetY: -5000 },
				custom(options) {
					const text = `${options.w.globals.categoryLabels[options.dataPointIndex]}: ${
						options.series[0][options.dataPointIndex] !== null
							? (roundFloat(options.series[0][options.dataPointIndex], 'down', 0) > 0
									? '+'
									: '') +
							  roundFloat(
									options.series[0][options.dataPointIndex],
									'down',
									0,
							  ).toLocaleString()
							: '없음'
					}`;
					setTooltipContent(text);
					return (
						'<div class="chart-tooltip">' +
						text +
						'<span class="chart-tooltip-tail">' +
						'<img src="image/tooltip_tail.svg"></img>' +
						'</span>' +
						'</div>'
					);
				},
			},
			legend: { show: false },
			series: [
				{
					name: 'line',
					type: 'line',
					data: result_list ?? new Array(6).fill(0),
				},
				{
					name: 'bar',
					type: 'bar',
					data: result_list ?? new Array(6).fill(0),
				},
			],
		};
	}, [result_list, is_axis_x]);

	return (
		<GraphCellInner>
			<CoreTooltip
				direction="down"
				text={tooltip_content}
				event_type="mousemove"
				_disabled={is_in_graph === false || tooltip_content === '' || is_scroll}
				// _disabled
			>
				<ReactApexChart options={chart} series={chart.series} />
			</CoreTooltip>
		</GraphCellInner>
	);
};

const GraphCellInner = styled.div`
	width: 160px;
	height: 49px;
	/* height: 60px; */
	overflow: hidden;
	padding-top: 15px;

	${({ theme }) => theme.common.flexCenter};
`;

export default React.memo(TableGraphCellInner);
